import Swiper from 'swiper';

import { View, Utils } from '../vendor/kerneljs';

const CardGrid = View.extend({
	initialize: function(){
		let element = this.find('.card-grid__inner'),
			nextButton = this.find('.js--slide-right'),
			prevButton = this.find('.js--slide-left');

		new Swiper(
			element,
			{
				wrapperClass: 'card-grid__slider',
				navigation: {
					nextEl: nextButton,
					prevEl: prevButton,
					disabledClass: 'is-disabled'
				},
				slideClass: 'card-grid__column',
				slidesPerView: 'auto',
				//initialSlide: element.dataset.middleIndex,
				centeredSlides: false,
				spaceBetween: 20,
				simulateTouch : true,
				roundLengths: true,
				touchStartPreventDefault: true,
				touchMoveStopPropagation: true,
				preventClicks: true
			});
	}
});

(function(){
	Utils.each(Utils.find('.js--card-grid'), function(elem) {
		new CardGrid( {el: elem} );
	});

})();

export default CardGrid;